module.exports = __webpack_public_path__ + "static/img/ai-robot-icon.8d201826.png";